export function initPageEnhancements() {
  const nameEl = document.querySelector('.home__name');
  if (nameEl) {
    nameEl.style.opacity = '1';
  }

  const counters = document.querySelectorAll('.counter');
  if (counters.length && 'IntersectionObserver' in window) {
    const counted = new Set();
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !counted.has(entry.target)) {
            counted.add(entry.target);
            const el = entry.target;
            const target = parseInt(el.getAttribute('data-target'), 10);
            const duration = 1500;
            const start = performance.now();
            function step(now) {
              const progress = Math.min((now - start) / duration, 1);
              const ease = 1 - (1 - progress) ** 3;
              el.textContent = String(Math.floor(ease * target));
              if (progress < 1) requestAnimationFrame(step);
              else el.textContent = String(target);
            }
            requestAnimationFrame(step);
          }
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach((c) => obs.observe(c));
  }

  if (window.innerWidth > 768) {
    document.querySelectorAll('.services__card, .ai-tool-card, .contact__card').forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        card.style.setProperty('--spot-x', `${e.clientX - r.left}px`);
        card.style.setProperty('--spot-y', `${e.clientY - r.top}px`);
      });
    });

    document.querySelectorAll('.services__card, .ai-tool-card').forEach((card) => {
      card.classList.add('tilt-card');
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const rx = ((y / rect.height) - 0.5) * -10;
        const ry = ((x / rect.width) - 0.5) * 10;
        card.style.transform = `perspective(800px) rotateX(${rx}deg) rotateY(${ry}deg) scale3d(1.03,1.03,1.03)`;
      });
      card.addEventListener('mouseleave', () => {
        card.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        card.style.transform = '';
        setTimeout(() => {
          card.style.transition = '';
        }, 500);
      });
    });
  }
}
